import OpenLink from 'components/common/open-link/OpenLink';
import { IS_CORDOVA } from 'constants/constants';
import { politicasDoccuments } from 'constants/doccuments/constants';
import React, { Component } from 'react';
import { Utils } from 'utils/UtilsDefault';

export default class ServiceTermsCheckout extends Component {
  openModal = (): void => {
    $('#ModalCompletePolitica').modal('show');
  };

  render() {
    /*  eslint-disable jsx-a11y/anchor-is-valid */
    const doccuments = (IS_CORDOVA || Utils.isMobileDevice()) ? politicasDoccuments['mobile'] : politicasDoccuments['desktop'];
    return (
      <>
        <OpenLink
          className="text-color-orange"
          to={doccuments.privacidade}
        >
          política de privacidade
        </OpenLink>
        {/* <a className="text-color-orange link" onClick={this.openModal}>política de privacidade</a> */}
      </>
    );
  }
}
